import { useEffect, useState } from "react";
import "./addEmployeeModal.css";
import useRTLContext from "../../../../hooks/useRTLContext";
import { useTranslation } from "react-i18next";

export const SalaryComponent = ({
  values,
  setFieldValue,
  totalSalary,
  handleSetTotalSalary,
}) => {
  // State for grossSalary
  const [grossSalary, setGrossSalary] = useState("0.00");
  const { isRTL, direction } = useRTLContext();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // Calculate grossSalary
    const grossSalaryValue = (
      (Number(values?.basicPay) || 0) +
      (Number(values?.housingAllows) || 0) +
      (Number(values?.transportAllows) || 0) +
      (Number(values?.foodAllows) || 0) +
      (Number(values?.otherAllows) || 0)
    ).toFixed(2);

    // Set grossSalary state
    setGrossSalary(grossSalaryValue);

    // Calculate GOSI deduction (if applicable)
    let gosiDeductionAmount = 0;
    if (values?.citizen === "true") {
      gosiDeductionAmount = (
        ((Number(values?.basicPay) || 0) +
          (Number(values?.housingAllows) || 0)) *
        (Number(values?.gosiDeduction) / 100)
      ).toFixed(2);

      setFieldValue("deductionAmount", gosiDeductionAmount);
    }

    // Calculate netSalary (totalSalary after GOSI deduction)
    const netSalary = (
      Number(grossSalaryValue) - Number(gosiDeductionAmount)
    ).toFixed(2);

    // Set netSalary (totalSalary)
    handleSetTotalSalary(netSalary);
  }, [
    values.basicPay,
    values.housingAllows,
    values.transportAllows,
    values.foodAllows,
    values.otherAllows,
    values.gosiDeduction,
    setFieldValue,
  ]);

  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="add-total-salary-container">
          <span className="add-total-sal">{t("Gross Salary")}</span>
          <span className="add-total-sal-amt">
            {t("SAR")} {grossSalary}
          </span>
        </div>
        <div className="add-total-salary-container">
          <span className="add-total-sal">{t("Net Salary")}</span>
          <span className="add-total-sal-amt">
            {t("SAR")} {totalSalary}
          </span>
        </div>
      </div>
    </>
  );
};
